import React, { useState } from 'react';
import { Check, X, Star, ShieldCheck, Zap, Wrench, Hammer, PaintRoller, Droplet, DollarSign } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { CTAButton } from './components/CTAButton';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  const checkoutUrl = 'https://checkout.descargatop.com/cart/40923243511857:1';
  const checkoutUrlPremium = 'https://checkout.descargatop.com/cart/40923243511857:1';
  const [selectedPlan, setSelectedPlan] = useState<'basico' | 'premium'>('premium');
  return <div className="min-h-screen bg-white pb-20" data-id="element-0">
      <CountdownTimer data-id="element-1" />

      {/* HERO SECTION */}
      <section className="pt-8 pb-12 px-4 max-w-5xl mx-auto text-center" data-id="element-2">
        <div className="inline-block bg-yellow-100 text-yellow-800 font-bold px-4 py-1 rounded-full text-sm md:text-base mb-6 border border-yellow-300" data-id="element-3">
          +3.247 HOMBRES YA CAMBIARON SU REALIDAD ⭐⭐⭐⭐⭐
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6 uppercase" data-id="element-4">
          Dejá de perder tiempo en cursos que no sirven…{' '}
          <span className="text-red-600" data-id="element-5">
            y empezá a generar ingresos con oficios reales
          </span>
        </h1>

        <p className="text-lg md:text-2xl text-gray-700 font-medium mb-8 max-w-4xl mx-auto" data-id="element-6">
          Aprendé 5 oficios prácticos desde cero y empezá a hacer — o cobrar —
          trabajos reales, aunque hoy no sepas nada.
        </p>

        <a href={checkoutUrl} className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 mb-8" data-id="element-7">
          <img src="https://cdn.magicpatterns.com/uploads/inexWJgBmR2pbXSZqxJPgt/mocap_jpg.jpg" alt="Mega Pack Maestro en Oficios" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl border-4 border-gray-100" data-id="element-8" />
        </a>

        <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-2xl p-6 md:p-8 max-w-3xl mx-auto mb-10" data-id="element-9">
          <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-10">
            🔧 MEGA PACK MAESTRO EN OFICIOS
          </h2>
          <h3 className="text-xl md:text-2xl text-blue-600 font-bold mb-6" data-id="element-11">
            ⚙️ Sistema Oficio Desde Cero™
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-12">
            <div className="flex items-center gap-3" data-id="element-13">
              <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-14" />
              <span className="font-semibold" data-id="element-15">Sin experiencia previa</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-16">
              <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-17" />
              <span className="font-semibold" data-id="element-18">
                Oficios que siempre tienen demanda
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-19">
              <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-20" />
              <span className="font-semibold" data-id="element-21">Podés empezar en semanas</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-22">
              <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-23" />
              <span className="font-semibold" data-id="element-24">
                Para tu casa o para generar ingresos
              </span>
            </div>
          </div>
        </div>

        <CTAButton subtext="Acceso inmediato · Pago seguro · Garantía 7 días" data-id="element-25">
          👇 QUIERO EMPEZAR A GANAR PLATA
        </CTAButton>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="bg-gray-900 text-white py-16 px-4" data-id="element-26">
        <div className="max-w-4xl mx-auto" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-4 text-yellow-400" data-id="element-28">
            Si hoy necesitás plata… esto es lo que te está frenando
          </h2>
          <p className="text-xl text-center text-gray-300 mb-12 font-medium" data-id="element-29">
            No es que no puedas. Es que nadie te mostró un camino claro para
            generar ingresos reales.
          </p>

          <div className="space-y-6" data-id="element-30">
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 flex gap-4 items-start" data-id="element-31">
              <X className="text-red-500 w-8 h-8 shrink-0 mt-1" data-id="element-32" />
              <div data-id="element-33">
                <h3 className="text-xl font-bold mb-1" data-id="element-34">
                  No tenés una habilidad concreta para cobrar
                </h3>
                <p className="text-gray-400" data-id="element-35">
                  Querés generar ingresos pero no sabés hacer algo que la gente
                  necesite
                </p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 flex gap-4 items-start" data-id="element-36">
              <X className="text-red-500 w-8 h-8 shrink-0 mt-1" data-id="element-37" />
              <div data-id="element-38">
                <h3 className="text-xl font-bold mb-1" data-id="element-39">
                  Probaste cursos que no sirven
                </h3>
                <p className="text-gray-400" data-id="element-40">
                  Videos sueltos, teoría que no aplicaste
                </p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 flex gap-4 items-start" data-id="element-41">
              <X className="text-red-500 w-8 h-8 shrink-0 mt-1" data-id="element-42" />
              <div data-id="element-43">
                <h3 className="text-xl font-bold mb-1" data-id="element-44">
                  Dependés de un sueldo que no alcanza
                </h3>
                <p className="text-gray-400" data-id="element-45">
                  Querés hacer algo por tu cuenta. Pero no sabés por dónde
                  empezar
                </p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 flex gap-4 items-start" data-id="element-46">
              <X className="text-red-500 w-8 h-8 shrink-0 mt-1" data-id="element-47" />
              <div data-id="element-48">
                <h3 className="text-xl font-bold mb-1" data-id="element-49">Tenés ganas…</h3>
                <p className="text-gray-400" data-id="element-50">pero la falta de orden te frena</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THE SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-51">
        <div className="max-w-4xl mx-auto text-center" data-id="element-52">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-53">
            💡 MEGA PACK MAESTRO EN OFICIOS
          </h2>
          <p className="text-2xl font-bold text-red-600 mb-2" data-id="element-54">
            Esto no es teoría.
          </p>
          <p className="text-xl font-bold text-gray-800 mb-8" data-id="element-55">
            Es formación práctica para salir a hacer.
          </p>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-56">
            Un sistema diseñado para que aprendas oficios que realmente se
            pagan.
          </p>

          <div className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-8 mb-12" data-id="element-57">
            <h3 className="text-2xl md:text-3xl font-black text-blue-800 mb-4" data-id="element-58">
              ⚙️ Sistema Oficio Desde Cero™
            </h3>
            <p className="text-lg text-blue-900 font-medium mb-8" data-id="element-59">
              Un sistema paso a paso que te lleva desde no saber nada… hasta
              poder hacer trabajos reales con seguridad.
            </p>

            <h4 className="text-xl font-bold mb-6" data-id="element-60">
              ⚙️ ¿Cómo funciona? 3 pilares que hacen la diferencia
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-61">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-blue-100" data-id="element-62">
                <div className="text-3xl font-black text-blue-300 mb-2" data-id="element-63">01</div>
                <h5 className="font-bold text-lg mb-2" data-id="element-64">Ruta por oficio</h5>
                <p className="text-gray-600 text-sm" data-id="element-65">
                  Seguís el orden correcto sin perderte
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-blue-100" data-id="element-66">
                <div className="text-3xl font-black text-blue-300 mb-2" data-id="element-67">02</div>
                <h5 className="font-bold text-lg mb-2" data-id="element-68">Trabajos reales</h5>
                <p className="text-gray-600 text-sm" data-id="element-69">
                  Aprendés haciendo desde el primer día
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-blue-100" data-id="element-70">
                <div className="text-3xl font-black text-blue-300 mb-2" data-id="element-71">03</div>
                <h5 className="font-bold text-lg mb-2" data-id="element-72">
                  Seguridad + monetización
                </h5>
                <p className="text-gray-600 text-sm" data-id="element-73">
                  Sabés qué evitar y cómo cobrar
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COMPARISON SECTION */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-74">
        <div className="max-w-4xl mx-auto" data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-10" data-id="element-76">
            🔥 Por qué esto funciona y YouTube no
          </h2>

          <div className="flex flex-col md:flex-row gap-6" data-id="element-77">
            <div className="flex-1 bg-white p-8 rounded-2xl shadow-md border border-gray-200" data-id="element-78">
              <h3 className="text-2xl font-bold text-center mb-6 text-gray-400" data-id="element-79">
                YouTube:
              </h3>
              <ul className="space-y-4" data-id="element-80">
                <li className="flex items-center gap-3 text-gray-500" data-id="element-81">
                  <X className="text-red-500 shrink-0" data-id="element-82" /> Videos sueltos
                </li>
                <li className="flex items-center gap-3 text-gray-500" data-id="element-83">
                  <X className="text-red-500 shrink-0" data-id="element-84" /> Sin orden
                </li>
                <li className="flex items-center gap-3 text-gray-500" data-id="element-85">
                  <X className="text-red-500 shrink-0" data-id="element-86" /> Sin guía
                </li>
              </ul>
            </div>

            <div className="flex-1 bg-gray-900 text-white p-8 rounded-2xl shadow-xl border-2 border-yellow-400 transform md:-translate-y-4" data-id="element-87">
              <h3 className="text-2xl font-bold text-center mb-6 text-yellow-400" data-id="element-88">
                Sistema Oficio Desde Cero™:
              </h3>
              <ul className="space-y-4" data-id="element-89">
                <li className="flex items-center gap-3 text-lg font-medium" data-id="element-90">
                  <Check className="text-green-400 shrink-0 w-6 h-6" data-id="element-91" /> Paso a
                  paso claro
                </li>
                <li className="flex items-center gap-3 text-lg font-medium" data-id="element-92">
                  <Check className="text-green-400 shrink-0 w-6 h-6" data-id="element-93" /> Todo
                  organizado
                </li>
                <li className="flex items-center gap-3 text-lg font-medium" data-id="element-94">
                  <Check className="text-green-400 shrink-0 w-6 h-6" data-id="element-95" />{' '}
                  Aplicación real
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT YOU CAN DO & GET */}
      <section className="py-16 px-4 bg-white" data-id="element-96">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-97">
          <div data-id="element-98">
            <h2 className="text-2xl md:text-3xl font-black mb-6 border-b-4 border-yellow-400 pb-2 inline-block" data-id="element-99">
              🔧 COSAS REALES QUE VAS A PODER HACER
            </h2>
            <ul className="space-y-4 mb-6" data-id="element-100">
              <li className="flex items-center gap-3 text-lg" data-id="element-101">
                <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-102" /> Cambiar
                enchufes
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-103">
                <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-104" /> Instalar
                lámparas
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-105">
                <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-106" /> Arreglar
                pérdidas
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-107">
                <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-108" /> Pintar
                ambientes
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-109">
                <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-110" /> Fabricar
                muebles
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-111">
                <Check className="text-green-500 w-6 h-6 shrink-0" data-id="element-112" /> Reparar
                paredes
              </li>
            </ul>
            <div className="bg-yellow-100 p-4 rounded-lg font-bold text-yellow-800 inline-flex items-center gap-2" data-id="element-113">
              👉 Para tu casa o para generar ingresos
            </div>
          </div>

          <div data-id="element-114">
            <h2 className="text-2xl md:text-3xl font-black mb-6 border-b-4 border-blue-500 pb-2 inline-block" data-id="element-115">
              📦 TODO LO QUE RECIBÍS
            </h2>
            <ul className="space-y-4" data-id="element-116">
              <li className="flex items-center gap-3 text-lg font-bold" data-id="element-117">
                <Check className="text-blue-500 w-6 h-6 shrink-0" data-id="element-118" /> 184 videos
                paso a paso
              </li>
              <li className="flex items-center gap-3 text-lg font-bold" data-id="element-119">
                <Check className="text-blue-500 w-6 h-6 shrink-0" data-id="element-120" /> 110+ PDFs
                descargables
              </li>
              <li className="flex items-center gap-3 text-lg font-bold" data-id="element-121">
                <Check className="text-blue-500 w-6 h-6 shrink-0" data-id="element-122" /> 5 oficios
                completos
              </li>
              <li className="flex items-center gap-3 text-lg font-bold" data-id="element-123">
                <Check className="text-blue-500 w-6 h-6 shrink-0" data-id="element-124" /> Sistema
                organizado
              </li>
              <li className="flex items-center gap-3 text-lg font-bold" data-id="element-125">
                <Check className="text-blue-500 w-6 h-6 shrink-0" data-id="element-126" /> Guía de
                monetización
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-127">
          <CTAButton className="mt-8" data-id="element-128">QUIERO ACCEDER A TODO ESTO</CTAButton>
        </div>
      </section>

      {/* THE 5 TRADES */}
      <section className="py-16 px-4 bg-gray-100" data-id="element-129">
        <div className="max-w-5xl mx-auto" data-id="element-130">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-12" data-id="element-131">
            🔥 LOS 5 OFICIOS COMPLETOS
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-132">
            {/* Plomería */}
            <div className="bg-white p-6 rounded-2xl shadow-lg border-t-4 border-blue-500" data-id="element-133">
              <a href="#comprar" className="block mb-4" data-id="element-134">
                <img src="https://cdn.magicpatterns.com/uploads/uME5umZd7UYDmMVA5sNhLb/mocap_plomeria.png" alt="Pack Plomería" className="w-full max-w-[280px] mx-auto rounded-lg shadow-md hover:scale-105 transition-transform cursor-pointer" data-id="element-135" />
              </a>
              <h3 className="text-xl font-black mb-2" data-id="element-136">
                Pack Plomería & Instalaciones Sanitarias
              </h3>
              <p className="text-sm text-gray-600 mb-4 h-10" data-id="element-137">
                Todo lo que necesitás para resolver trabajos de agua con
                seguridad.
              </p>
              <ul className="space-y-2 text-sm font-medium mb-4" data-id="element-138">
                <li className="flex gap-2" data-id="element-139">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-140" />{' '}
                  Instalaciones de agua fría y caliente
                </li>
                <li className="flex gap-2" data-id="element-141">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-142" />{' '}
                  Sistemas de desagüe
                </li>
                <li className="flex gap-2" data-id="element-143">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-144" />{' '}
                  Reparaciones frecuentes
                </li>
                <li className="flex gap-2" data-id="element-145">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-146" />{' '}
                  Trabajo con materiales
                </li>
                <li className="flex gap-2" data-id="element-147">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-148" />{' '}
                  Aplicación en viviendas y obras
                </li>
              </ul>
              <div className="bg-gray-50 p-2 rounded text-center font-bold text-blue-700 text-sm" data-id="element-149">
                👉 Habilidad práctica y rentable
              </div>
            </div>

            {/* Carpintería */}
            <div className="bg-white p-6 rounded-2xl shadow-lg border-t-4 border-amber-600" data-id="element-150">
              <a href="#comprar" className="block mb-4" data-id="element-151">
                <img src="https://cdn.magicpatterns.com/uploads/vVKwfEAzw7PNcxYBjiMwi7/mocap_carpinteria.png" alt="Pack Carpintería" className="w-full max-w-[280px] mx-auto rounded-lg shadow-md hover:scale-105 transition-transform cursor-pointer" data-id="element-152" />
              </a>
              <h3 className="text-xl font-black mb-2" data-id="element-153">
                Pack Carpintería & Muebles a Medida
              </h3>
              <p className="text-sm text-gray-600 mb-4 h-10" data-id="element-154">
                Diseñá, fabricá y vendé muebles desde cero
              </p>
              <ul className="space-y-2 text-sm font-medium mb-4" data-id="element-155">
                <li className="flex gap-2" data-id="element-156">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-157" />{' '}
                  Muebles funcionales
                </li>
                <li className="flex gap-2" data-id="element-158">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-159" />{' '}
                  Trabajo con melamina
                </li>
                <li className="flex gap-2" data-id="element-160">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-161" />{' '}
                  Diseño y armado
                </li>
                <li className="flex gap-2" data-id="element-162">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-163" />{' '}
                  Técnicas de terminación
                </li>
                <li className="flex gap-2" data-id="element-164">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-165" />{' '}
                  Base para emprender
                </li>
              </ul>
              <div className="bg-gray-50 p-2 rounded text-center font-bold text-amber-700 text-sm" data-id="element-166">
                👉 Convertí esto en ingresos
              </div>
            </div>

            {/* Construcción */}
            <div className="bg-white p-6 rounded-2xl shadow-lg border-t-4 border-orange-500" data-id="element-167">
              <a href="#comprar" className="block mb-4" data-id="element-168">
                <img src="https://cdn.magicpatterns.com/uploads/sE4og2CVFKMBngvM7cdByq/mocap_albanil.png" alt="Pack Albañilería" className="w-full max-w-[280px] mx-auto rounded-lg shadow-md hover:scale-105 transition-transform cursor-pointer" data-id="element-169" />
              </a>
              <h3 className="text-xl font-black mb-2" data-id="element-170">
                Pack Construcción & Albañilería
              </h3>
              <p className="text-sm text-gray-600 mb-4 h-10" data-id="element-171">
                Aprendé trabajos reales de obra
              </p>
              <ul className="space-y-2 text-sm font-medium mb-4" data-id="element-172">
                <li className="flex gap-2" data-id="element-173">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-174" />{' '}
                  Ampliaciones
                </li>
                <li className="flex gap-2" data-id="element-175">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-176" />{' '}
                  Terminaciones
                </li>
                <li className="flex gap-2" data-id="element-177">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-178" />{' '}
                  Reparaciones
                </li>
                <li className="flex gap-2" data-id="element-179">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-180" />{' '}
                  Organización de obra
                </li>
                <li className="flex gap-2" data-id="element-181">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-182" />{' '}
                  Sistemas modernos
                </li>
              </ul>
              <div className="bg-gray-50 p-2 rounded text-center font-bold text-orange-700 text-sm" data-id="element-183">
                👉 Base para crecer
              </div>
            </div>

            {/* Pintura */}
            <div className="bg-white p-6 rounded-2xl shadow-lg border-t-4 border-purple-500 md:col-start-1 lg:col-start-auto" data-id="element-184">
              <a href="#comprar" className="block mb-4" data-id="element-185">
                <img src="https://cdn.magicpatterns.com/uploads/tnibfpKCzM6bPoPMAM4Ry1/ChatGPT_Image_30_mar_2026,_08_02_03_p.m..png" alt="Pack Pintura" className="w-full max-w-[280px] mx-auto rounded-lg shadow-md hover:scale-105 transition-transform cursor-pointer" data-id="element-186" />
              </a>
              <h3 className="text-xl font-black mb-2" data-id="element-187">
                Pack Pintura & Terminaciones
              </h3>
              <p className="text-sm text-gray-600 mb-4 h-10" data-id="element-188">
                Uno de los servicios más rápidos
              </p>
              <ul className="space-y-2 text-sm font-medium mb-4" data-id="element-189">
                <li className="flex gap-2" data-id="element-190">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-191" />{' '}
                  Pintura profesional
                </li>
                <li className="flex gap-2" data-id="element-192">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-193" />{' '}
                  Preparación de superficies
                </li>
                <li className="flex gap-2" data-id="element-194">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-195" />{' '}
                  Técnicas de aplicación
                </li>
                <li className="flex gap-2" data-id="element-196">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-197" />{' '}
                  Mejora de espacios
                </li>
                <li className="flex gap-2" data-id="element-198">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-199" />{' '}
                  Baja inversión
                </li>
              </ul>
              <div className="bg-gray-50 p-2 rounded text-center font-bold text-purple-700 text-sm" data-id="element-200">
                👉 Ideal para empezar rápido
              </div>
            </div>

            {/* Electricidad */}
            <div className="bg-white p-6 rounded-2xl shadow-lg border-t-4 border-yellow-400 md:col-start-2 lg:col-start-auto" data-id="element-201">
              <a href="#comprar" className="block mb-4" data-id="element-202">
                <img src="https://cdn.magicpatterns.com/uploads/4zYweYPXAjfHSavr3SEGWZ/mocap_electricidad.png" alt="Pack Electricidad" className="w-full max-w-[280px] mx-auto rounded-lg shadow-md hover:scale-105 transition-transform cursor-pointer" data-id="element-203" />
              </a>
              <h3 className="text-xl font-black mb-2" data-id="element-204">Pack Electricidad</h3>
              <p className="text-sm text-gray-600 mb-4 h-10" data-id="element-205">
                Uno de los oficios más demandados
              </p>
              <ul className="space-y-2 text-sm font-medium mb-4" data-id="element-206">
                <li className="flex gap-2" data-id="element-207">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-208" />{' '}
                  Instalaciones eléctricas
                </li>
                <li className="flex gap-2" data-id="element-209">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-210" />{' '}
                  Cableado
                </li>
                <li className="flex gap-2" data-id="element-211">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-212" />{' '}
                  Tableros
                </li>
                <li className="flex gap-2" data-id="element-213">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-214" />{' '}
                  Diagnóstico de fallas
                </li>
                <li className="flex gap-2" data-id="element-215">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-216" />{' '}
                  Seguridad
                </li>
              </ul>
              <div className="bg-gray-50 p-2 rounded text-center font-bold text-yellow-700 text-sm" data-id="element-217">
                👉 Alta demanda
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BONUS & INCOME SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-218">
        <div className="max-w-4xl mx-auto" data-id="element-219">
          {/* BONUS */}
          <div className="bg-gray-900 text-white rounded-3xl p-8 md:p-12 shadow-2xl mb-16 relative overflow-hidden" data-id="element-220">
            <div className="absolute top-0 right-0 bg-red-600 text-white font-black py-2 px-8 transform translate-x-8 translate-y-6 rotate-45 shadow-lg" data-id="element-221">
              GRATIS POR HOY
            </div>

            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-222">
              <div className="w-full md:w-1/2" data-id="element-223">
                <a href={checkoutUrl} className="block cursor-pointer transform hover:scale-105 transition-transform" data-id="element-224">
                  <img src="https://cdn.magicpatterns.com/uploads/rUZPq9VVwb1177nJSbEgqY/bono_1_pack_oficio.png" alt="Bono Monetización" className="w-full max-w-sm mx-auto drop-shadow-2xl" data-id="element-225" />
                </a>
              </div>
              <div className="w-full md:w-1/2" data-id="element-226">
                <h2 className="text-3xl md:text-4xl font-black text-yellow-400 mb-6" data-id="element-227">
                  💰 BONUS — MONETIZACIÓN
                </h2>
                <ul className="space-y-4 text-lg" data-id="element-228">
                  <li className="flex items-center gap-3" data-id="element-229">
                    <Check className="text-green-400 w-6 h-6 shrink-0" data-id="element-230" />{' '}
                    Conseguir clientes
                  </li>
                  <li className="flex items-center gap-3" data-id="element-231">
                    <Check className="text-green-400 w-6 h-6 shrink-0" data-id="element-232" /> Qué
                    trabajos hacer
                  </li>
                  <li className="flex items-center gap-3" data-id="element-233">
                    <Check className="text-green-400 w-6 h-6 shrink-0" data-id="element-234" /> Cómo
                    cobrar
                  </li>
                  <li className="flex items-center gap-3" data-id="element-235">
                    <Check className="text-green-400 w-6 h-6 shrink-0" data-id="element-236" /> Cómo
                    escalar
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* INCOME */}
          <div className="text-center mb-12" data-id="element-237">
            <h2 className="text-3xl md:text-4xl font-black mb-8" data-id="element-238">
              💸 ESTO SE TRADUCE EN INGRESOS
            </h2>

            <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto mb-8" data-id="element-239">
              <ul className="space-y-4 text-lg md:text-xl font-bold text-gray-800 text-left max-w-sm mx-auto" data-id="element-240">
                <li className="flex justify-between border-b border-green-200 pb-2" data-id="element-241">
                  <span data-id="element-242">Arreglo eléctrico</span>{' '}
                  <span className="text-green-700" data-id="element-243">→ $15.000 – $45.000</span>
                </li>
                <li className="flex justify-between border-b border-green-200 pb-2" data-id="element-244">
                  <span data-id="element-245">Plomería</span>{' '}
                  <span className="text-green-700" data-id="element-246">→ $15.000 – $75.000</span>
                </li>
                <li className="flex justify-between border-b border-green-200 pb-2" data-id="element-247">
                  <span data-id="element-248">Carpintería</span>{' '}
                  <span className="text-green-700" data-id="element-249">→ $27.000+</span>
                </li>
                <li className="flex justify-between" data-id="element-250">
                  <span data-id="element-251">Pintura</span>{' '}
                  <span className="text-green-700" data-id="element-252">→ $15.000 x m²</span>
                </li>
              </ul>
            </div>

            <div className="text-xl md:text-2xl font-black text-red-600 mb-10 bg-red-50 inline-block px-6 py-3 rounded-full border border-red-200" data-id="element-253">
              👉 Con 1 o 2 trabajos recuperás la inversión
            </div>

            <CTAButton data-id="element-254">🔥 QUIERO EMPEZAR AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-255">
        <div className="max-w-6xl mx-auto" data-id="element-256">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-257">
            Lo que dicen quienes ya empezaron
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-258">
            {/* Testimonial 1 */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-259">
              <div className="flex text-yellow-400 mb-3" data-id="element-260">
                <Star fill="currentColor" data-id="element-261" />
                <Star fill="currentColor" data-id="element-262" />
                <Star fill="currentColor" data-id="element-263" />
                <Star fill="currentColor" data-id="element-264" />
                <Star fill="currentColor" data-id="element-265" />
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-266">
                "Estaba cansado de mi sueldo en la fábrica. Empecé con el módulo
                de electricidad los fines de semana y ya estoy sacando casi lo
                mismo que en mi trabajo fijo solo haciendo changas en mi barrio.
                Muy bien explicado todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-267">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center font-bold text-blue-800" data-id="element-268">
                  M
                </div>
                <div data-id="element-269">
                  <p className="font-bold text-sm" data-id="element-270">Marcelo, 34 años</p>
                  <p className="text-xs text-gray-500" data-id="element-271">Buenos Aires</p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-272">
              <div className="flex text-yellow-400 mb-3" data-id="element-273">
                <Star fill="currentColor" data-id="element-274" />
                <Star fill="currentColor" data-id="element-275" />
                <Star fill="currentColor" data-id="element-276" />
                <Star fill="currentColor" data-id="element-277" />
                <Star fill="currentColor" data-id="element-278" />
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-279">
                "No sabía agarrar un destornillador. El paso a paso es a prueba
                de tontos. Ya arreglé todas las pérdidas de mi casa y le armé un
                mueble a mi señora. Ahora un vecino me pidió que le pinte el
                frente y le pasé presupuesto."
              </p>
              <div className="flex items-center gap-3" data-id="element-280">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center font-bold text-green-800" data-id="element-281">
                  J
                </div>
                <div data-id="element-282">
                  <p className="font-bold text-sm" data-id="element-283">Javier, 41 años</p>
                  <p className="text-xs text-gray-500" data-id="element-284">Córdoba</p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-285">
              <div className="flex text-yellow-400 mb-3" data-id="element-286">
                <Star fill="currentColor" data-id="element-287" />
                <Star fill="currentColor" data-id="element-288" />
                <Star fill="currentColor" data-id="element-289" />
                <Star fill="currentColor" data-id="element-290" />
                <Star fill="currentColor" data-id="element-291" />
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-292">
                "Compré otros cursos antes y era pura teoría aburrida. Esto es
                directo al grano. Te dicen qué comprar, cómo hacerlo y cuánto
                cobrar. El bono de monetización vale oro puro."
              </p>
              <div className="flex items-center gap-3" data-id="element-293">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center font-bold text-red-800" data-id="element-294">
                  D
                </div>
                <div data-id="element-295">
                  <p className="font-bold text-sm" data-id="element-296">Diego, 28 años</p>
                  <p className="text-xs text-gray-500" data-id="element-297">Santa Fe</p>
                </div>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 md:col-start-1 lg:col-start-auto" data-id="element-298">
              <div className="flex text-yellow-400 mb-3" data-id="element-299">
                <Star fill="currentColor" data-id="element-300" />
                <Star fill="currentColor" data-id="element-301" />
                <Star fill="currentColor" data-id="element-302" />
                <Star fill="currentColor" data-id="element-303" />
                <Star fill="currentColor" data-id="element-304" />
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-305">
                "Me quedé sin laburo hace 2 meses. Con la indemnización compré
                herramientas y este pack. Me mandé con plomería y ya tengo
                clientes fijos. Te da la seguridad que te falta para mandarte."
              </p>
              <div className="flex items-center gap-3" data-id="element-306">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center font-bold text-purple-800" data-id="element-307">
                  R
                </div>
                <div data-id="element-308">
                  <p className="font-bold text-sm" data-id="element-309">Rubén, 47 años</p>
                  <p className="text-xs text-gray-500" data-id="element-310">Mendoza</p>
                </div>
              </div>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 md:col-start-2 lg:col-start-auto" data-id="element-311">
              <div className="flex text-yellow-400 mb-3" data-id="element-312">
                <Star fill="currentColor" data-id="element-313" />
                <Star fill="currentColor" data-id="element-314" />
                <Star fill="currentColor" data-id="element-315" />
                <Star fill="currentColor" data-id="element-316" />
                <Star fill="currentColor" data-id="element-317" />
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-318">
                "Excelente inversión. Lo recuperé con el primer trabajo de
                electricidad que hice (cambiar un tablero). Si tenés ganas de
                laburar y salir adelante, este es el camino."
              </p>
              <div className="flex items-center gap-3" data-id="element-319">
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center font-bold text-orange-800" data-id="element-320">
                  G
                </div>
                <div data-id="element-321">
                  <p className="font-bold text-sm" data-id="element-322">Gastón, 31 años</p>
                  <p className="text-xs text-gray-500" data-id="element-323">Tucumán</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white text-center" id="comprar" data-id="element-324">
        <div className="max-w-3xl mx-auto" data-id="element-325">
          <h2 className="text-4xl md:text-5xl font-black text-yellow-400 mb-4 uppercase tracking-wider" data-id="element-326">
            ELEGÍ TU PLAN Y EMPEZÁ HOY
          </h2>
          <p className="text-gray-300 text-lg mb-2" data-id="element-327">
            Descarga inmediata. Acceso de por vida.
          </p>
          <p className="text-yellow-400 font-bold mb-10" data-id="element-328">
            🏆 Elegí tu plan y dale a COMPRAR AHORA
          </p>

          <div className="space-y-4 mb-8" data-id="element-329">
            {/* PACK MAESTRO */}
            <div onClick={() => setSelectedPlan('basico')} className={`cursor-pointer rounded-2xl p-6 md:p-8 text-left transition-all duration-300 border-2 ${selectedPlan === 'basico' ? 'border-yellow-400 bg-gray-800 shadow-lg shadow-yellow-400/20' : 'border-gray-700 bg-gray-800/50 opacity-70 hover:opacity-90'}`} data-id="element-330">
              <div className="flex items-start justify-between gap-4" data-id="element-331">
                <div className="flex items-start gap-4" data-id="element-332">
                  <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selectedPlan === 'basico' ? 'border-yellow-400 bg-yellow-400' : 'border-gray-500'}`} data-id="element-333">
                    {selectedPlan === 'basico' && <div className="w-3 h-3 bg-gray-900 rounded-full" data-id="element-334" />}
                  </div>
                  <div data-id="element-335">
                    <h3 className="text-xl md:text-2xl font-black" data-id="element-336">
                      PACK MAESTRO EN OFICIOS
                    </h3>
                    <p className="text-gray-400 text-sm mt-1" data-id="element-337">
                      5 oficios completos + bono monetización
                    </p>
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-338">
                  <span className="text-gray-500 text-lg line-through" data-id="element-339">
                    $39.998
                  </span>
                  <div className="text-3xl md:text-4xl font-black text-green-400" data-id="element-340">
                    $19.999
                  </div>
                </div>
              </div>

              {selectedPlan === 'basico' && <div className="mt-6 pt-6 border-t border-gray-700 grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-341">
                  <div className="flex items-center gap-2 text-sm" data-id="element-342">
                    <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-343" /> 5
                    oficios completos
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-344">
                    <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-345" /> 184
                    videos paso a paso
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-346">
                    <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-347" /> 110+
                    PDFs descargables
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-348">
                    <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-349" /> Bono
                    monetización
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-350">
                    <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-351" /> Acceso
                    inmediato
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-352">
                    <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-353" /> Acceso
                    de por vida
                  </div>
                </div>}
            </div>

            {/* PACK PREMIUM */}
            <div onClick={() => setSelectedPlan('premium')} className={`cursor-pointer rounded-2xl p-6 md:p-8 text-left transition-all duration-300 border-2 relative ${selectedPlan === 'premium' ? 'border-yellow-400 bg-gray-800 shadow-lg shadow-yellow-400/20' : 'border-gray-700 bg-gray-800/50 opacity-70 hover:opacity-90'}`} data-id="element-354">
              <div className="absolute -top-3 right-4 flex gap-2" data-id="element-355">
                <span className="bg-red-600 text-white text-xs font-black px-3 py-1 rounded-full uppercase" data-id="element-356">
                  Más elegido
                </span>
                <span className="bg-green-600 text-white text-xs font-black px-3 py-1 rounded-full uppercase" data-id="element-357">
                  Mejor valor
                </span>
              </div>

              <div className="flex items-start justify-between gap-4" data-id="element-358">
                <div className="flex items-start gap-4" data-id="element-359">
                  <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selectedPlan === 'premium' ? 'border-yellow-400 bg-yellow-400' : 'border-gray-500'}`} data-id="element-360">
                    {selectedPlan === 'premium' && <div className="w-3 h-3 bg-gray-900 rounded-full" data-id="element-361" />}
                  </div>
                  <div data-id="element-362">
                    <h3 className="text-xl md:text-2xl font-black" data-id="element-363">
                      PACK PREMIUM
                    </h3>
                    <p className="text-gray-400 text-sm mt-1" data-id="element-364">
                      Todo el Pack Maestro + 10 oficios extra con alta salida
                      laboral
                    </p>
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-365">
                  <span className="text-gray-500 text-lg line-through" data-id="element-366">
                    $59.998
                  </span>
                  <div className="text-3xl md:text-4xl font-black text-green-400" data-id="element-367">
                    $29.999
                  </div>
                </div>
              </div>

              {selectedPlan === 'premium' && <div className="mt-6 pt-6 border-t border-gray-700" data-id="element-368">
                  <p className="text-yellow-400 font-bold text-sm mb-4" data-id="element-369">
                    ✨ TODO LO DEL PACK MAESTRO +
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-370">
                    <div className="flex items-center gap-2 text-sm" data-id="element-371">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-372" />{' '}
                      Calentadores de Agua
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-373">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-374" />{' '}
                      Construcción en Steel Frame / Durlock
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-375">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-376" />{' '}
                      Herrería
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-377">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-378" />{' '}
                      Instalación de Paneles Solares
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-379">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-380" />{' '}
                      Manual del Soldador (Soldadura)
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-381">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-382" />{' '}
                      Melamina (Carpintería en melamina)
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-383">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-384" />{' '}
                      Neumática
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-385">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-386" />{' '}
                      Reparación de Electrodomésticos
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-387">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-388" />{' '}
                      Tornería
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-389">
                      <Check className="w-4 h-4 text-yellow-400 shrink-0" data-id="element-390" />{' '}
                      Ventilación y Aire Acondicionado
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-391">
                      <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-392" />{' '}
                      Descarga digital
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-393">
                      <Check className="w-4 h-4 text-green-400 shrink-0" data-id="element-394" />{' '}
                      Acceso de por vida
                    </div>
                  </div>
                </div>}
            </div>
          </div>

          <p className="text-yellow-400 text-sm font-bold mb-6" data-id="element-395">
            🔥 El 80% de nuestros clientes elige el Pack Premium. Es el que más
            valor tiene por su precio.
          </p>

          <a href={selectedPlan === 'premium' ? checkoutUrlPremium : checkoutUrl} className="block w-full max-w-xl mx-auto bg-green-500 hover:bg-green-600 text-white font-montserrat font-black text-2xl md:text-3xl py-6 px-8 rounded-2xl transition-all text-center uppercase tracking-wide shadow-2xl hover:scale-105 border-b-4 border-green-700" data-id="element-396">
            🛒 COMPRAR AHORA
          </a>

          <div className="mt-4 flex flex-wrap justify-center gap-4 text-sm font-bold text-gray-400" data-id="element-397">
            <span className="flex items-center gap-1" data-id="element-398">
              <Zap className="w-4 h-4 text-yellow-500" data-id="element-399" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-400">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-401" /> Garantía de 7
              días
            </span>
          </div>

          <div className="flex flex-col items-center justify-center gap-4 mt-12" data-id="element-402">
            <ShieldCheck className="w-16 h-16 text-green-400" data-id="element-403" />
            <h3 className="text-2xl font-black" data-id="element-404">🔒 GARANTÍA SIN RIESGO</h3>
            <p className="text-xl text-gray-300" data-id="element-405">
              Si no te sirve, te devolvemos el dinero
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-yellow-400 text-black text-center" data-id="element-406">
        <div className="max-w-2xl mx-auto" data-id="element-407">
          <h2 className="text-4xl md:text-6xl font-black mb-6 uppercase" data-id="element-408">
            🔥 ¿VAS A SEGUIR ESPERANDO O VAS A EMPEZAR?
          </h2>
          <p className="text-2xl md:text-3xl font-bold mb-2" data-id="element-409">
            No necesitás saber todo.
          </p>
          <p className="text-3xl md:text-4xl font-black mb-10 text-red-600" data-id="element-410">
            Necesitás empezar.
          </p>

          <a href={checkoutUrl} className="block w-full max-w-xl mx-auto bg-black hover:bg-gray-900 text-white font-montserrat font-black text-2xl md:text-3xl py-6 px-8 rounded-xl transition-all text-center uppercase tracking-wide shadow-2xl hover:scale-105" data-id="element-411">
            👇 QUIERO EMPEZAR HOY
          </a>

          <p className="mt-8 font-bold text-lg flex items-center justify-center gap-2" data-id="element-412">
            🔥 +3.758 personas ya lo descargaron
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-black text-gray-400 text-center py-8 px-4" data-id="element-413">
        <p className="text-sm font-medium mb-2" data-id="element-414">
          © 2026 DescargaTop – Megapack Maestro en oficios
        </p>
        <p className="text-sm mb-3" data-id="element-415">Todos los derechos reservados</p>
        <p className="text-xs text-gray-500" data-id="element-416">
          <a href="#" className="hover:text-white transition-colors" data-id="element-417">
            Privacidad
          </a>
          {' · '}
          <a href="#" className="hover:text-white transition-colors" data-id="element-418">
            Términos y Condiciones
          </a>
        </p>
      </footer>

      <SocialProofPopup data-id="element-419" />
    </div>;
}